import axios from 'axios';
import { message } from 'antd';
import {
  CUSTOMER_API
} from '../../../constants/API';
import {
  CREATE_CUSTOMER_LOADING
} from '../types';


function createCustomer(data) {
  return async(dispatch, getState) => {
      dispatch({
        type: CREATE_CUSTOMER_LOADING,
        creatingCustomer: true
      });
      try {
        const accessToken = await localStorage.getItem('accessToken');
        const { userData } = getState().AuthReducer;
        const postData = {
          ...data,
          userId: userData.id
        };
        const customerReponse = await axios.post(CUSTOMER_API, postData, { headers: {"Authorization" : `Bearer ${accessToken}`} });
        const { id } = customerReponse.data

        dispatch({
          type: CREATE_CUSTOMER_LOADING,
          creatingCustomer: false
        });
        return id;
      } catch (e) {
        message.error(String(e));
        dispatch({
          type: CREATE_CUSTOMER_LOADING,
          creatingCustomer: false
        });
        console.log(e);
      }
  }
}
export default createCustomer;
